(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["retroease-a90e-audience"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('a90-audience-slider')) {
    customElements.define('a90-audience-slider', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-audience-rail]');
        this.previousButton = this.querySelector('[data-audience-previous]');
        this.nextButton = this.querySelector('[data-audience-next]');
        if (!this.rail || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.rail.addEventListener('scroll', () => this.update(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.update());
        this.resizeObserver.observe(this.rail);
        this.update();
      }

      disconnectedCallback() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      move(direction) {
        const card = this.rail.querySelector('.ra-audience__card');
        if (!card) return;
        const gap = Number.parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      update() {
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        const hasOverflow = maximum > 2;
        this.previousButton.hidden = !hasOverflow;
        this.nextButton.hidden = !hasOverflow;
        this.previousButton.disabled = this.rail.scrollLeft <= 2;
        this.nextButton.disabled = this.rail.scrollLeft >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-about-certifications"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('retroease-cert-tabs')) {
    class RetroEaseCertTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-cert-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-cert-panel]'));
        this.status = this.querySelector('[aria-live]');
        if (this.tabs.length === 0 || this.panels.length === 0) return;

        this.classList.add('is-ready');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.selectTab(index, true));
          tab.addEventListener('keydown', (event) => this.handleKeydown(event, index));
        });
        this.selectTab(0, false);
      }

      selectTab(nextIndex, announce) {
        const activeIndex = this.tabs.findIndex((tab) => tab.getAttribute('aria-selected') === 'true');
        const direction = nextIndex < activeIndex ? 'previous' : 'next';

        for (let index = 0; index < this.tabs.length; index += 1) {
          const isActive = index === nextIndex;
          this.tabs[index].setAttribute('aria-selected', String(isActive));
          this.tabs[index].setAttribute('tabindex', isActive ? '0' : '-1');
          this.panels[index].hidden = !isActive;
          this.panels[index].classList.remove('is-active', 'is-entering-next', 'is-entering-previous');

          if (isActive) {
            this.panels[index].classList.add('is-active', `is-entering-${direction}`);
          }
        }

        if (announce && this.status) {
          this.status.textContent = '';
          requestAnimationFrame(() => {
            this.status.textContent = this.tabs[nextIndex].textContent.trim();
          });
        }
      }

      handleKeydown(event, currentIndex) {
        let nextIndex = currentIndex;
        if (event.key === 'ArrowRight') nextIndex = (currentIndex + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') nextIndex = (currentIndex - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        if (nextIndex === currentIndex) return;

        event.preventDefault();
        this.selectTab(nextIndex, true);
        this.tabs[nextIndex].focus();
      }
    }

    customElements.define('retroease-cert-tabs', RetroEaseCertTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-about-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('retroease-hero-media')) {
    class RetroEaseHeroMedia extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.control = this.querySelector('button');
        if (!this.video || !this.control) return;

        this.playLabel = this.dataset.playLabel;
        this.pauseLabel = this.dataset.pauseLabel;
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.handleToggle = this.togglePlayback.bind(this);
        this.handleEnded = this.showPoster.bind(this);
        this.handlePlay = this.showPlaying.bind(this);
        this.handlePause = this.showPaused.bind(this);

        this.control.addEventListener('click', this.handleToggle);
        this.video.addEventListener('ended', this.handleEnded);
        this.video.addEventListener('play', this.handlePlay);
        this.video.addEventListener('pause', this.handlePause);

        if (this.reducedMotion || this.dataset.autoplay !== 'true') {
          this.video.pause();
          this.classList.add('is-ended');
          this.updateControl(false);
        } else {
          this.video.play().catch(() => {
            this.classList.add('is-ended');
            this.updateControl(false);
          });
        }
      }

      disconnectedCallback() {
        if (!this.video || !this.control) return;
        this.control.removeEventListener('click', this.handleToggle);
        this.video.removeEventListener('ended', this.handleEnded);
        this.video.removeEventListener('play', this.handlePlay);
        this.video.removeEventListener('pause', this.handlePause);
      }

      togglePlayback() {
        if (this.video.ended || this.classList.contains('is-ended')) {
          this.classList.remove('is-ended');
          this.video.currentTime = 0;
          this.video.play().catch(() => this.showPoster());
          return;
        }

        if (this.video.paused) {
          this.video.play().catch(() => this.showPaused());
        } else {
          this.video.pause();
        }
      }

      showPoster() {
        this.classList.remove('is-paused');
        this.classList.add('is-ended');
        this.updateControl(false);
      }

      showPlaying() {
        this.classList.remove('is-ended', 'is-paused');
        this.updateControl(true);
      }

      showPaused() {
        if (this.video.ended) return;
        this.classList.add('is-paused');
        this.updateControl(false);
      }

      updateControl(isPlaying) {
        this.control.setAttribute('aria-label', isPlaying ? this.pauseLabel : this.playLabel);
      }
    }

    customElements.define('retroease-hero-media', RetroEaseHeroMedia);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-about-logistics"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('retroease-logistics')) {
    class RetroEaseLogistics extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.classList.add('is-reveal-ready');
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              this.classList.add('is-visible');
              this.observer.disconnect();
            }
          },
          { threshold: 0.12 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    customElements.define('retroease-logistics', RetroEaseLogistics);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-about-story"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('retroease-story-row')) {
    class RetroEaseStoryRow extends HTMLElement {
      connectedCallback() {
        if (!('IntersectionObserver' in window)) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.classList.add('is-reveal-ready');
        this.observer = new IntersectionObserver(
          (entries) => {
            for (const entry of entries) {
              if (!entry.isIntersecting) continue;
              this.classList.add('is-visible');
              this.observer.disconnect();
            }
          },
          { threshold: 0.16 }
        );
        this.observer.observe(this);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
      }
    }

    customElements.define('retroease-story-row', RetroEaseStoryRow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-asomtom-detail-showcase"] && !Shopify.designMode) return;
  try {
    
  class RetroeaseAsomtomDetailShowcase extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-detail-reveal]')];
      if (this.items.length === 0) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) return;

      this.classList.add('is-reveal-ready');
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        }
      }, {
        threshold: 0.01,
        rootMargin: '0px 0px -60px 0px'
      });

      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('retroease-asomtom-detail-showcase')) {
    customElements.define('retroease-asomtom-detail-showcase', RetroeaseAsomtomDetailShowcase);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-asomtom-scene-gallery"] && !Shopify.designMode) return;
  try {
    
  class RetroeaseAsomtomSceneGallery extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-scene-reveal]')];
      if (this.items.length === 0) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) return;

      this.classList.add('is-reveal-ready');
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        }
      }, {
        threshold: 0.01,
        rootMargin: '0px 0px -60px 0px'
      });

      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('retroease-asomtom-scene-gallery')) {
    customElements.define('retroease-asomtom-scene-gallery', RetroeaseAsomtomSceneGallery);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-asomtom-selling-points"] && !Shopify.designMode) return;
  try {
    
  class RetroeaseAsomtomSellingPoints extends HTMLElement {
    connectedCallback() {
      this.items = [...this.querySelectorAll('[data-selling-reveal]')];
      if (this.items.length === 0) return;

      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduceMotion || !('IntersectionObserver' in window)) return;

      this.classList.add('is-reveal-ready');
      this.observer = new IntersectionObserver((entries) => {
        for (const entry of entries) {
          if (!entry.isIntersecting) continue;
          entry.target.classList.add('is-visible');
          this.observer.unobserve(entry.target);
        }
      }, {
        threshold: 0.01,
        rootMargin: '0px 0px -60px 0px'
      });

      this.items.forEach((item) => this.observer.observe(item));
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }
  }

  if (!customElements.get('retroease-asomtom-selling-points')) {
    customElements.define('retroease-asomtom-selling-points', RetroeaseAsomtomSellingPoints);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-related-picks"] && !Shopify.designMode) return;
  try {
    
  class RetroeaseRelatedPicks extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-related-picks-viewport]');
      this.controls = this.querySelectorAll('[data-related-picks-scroll]');

      this.controls.forEach((control) => {
        control.addEventListener('click', () => {
          const direction = control.dataset.relatedPicksScroll === 'previous' ? -1 : 1;
          const scrollAmount = this.viewport.clientWidth * 0.76 * direction;

          this.viewport.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  if (!customElements.get('retroease-related-picks')) {
    customElements.define('retroease-related-picks', RetroeaseRelatedPicks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["retroease-tuijian"] && !Shopify.designMode) return;
  try {
    
  class RetroeaseRelatedPicks extends HTMLElement {
    connectedCallback() {
      this.viewport = this.querySelector('[data-related-picks-viewport]');
      this.controls = this.querySelectorAll('[data-related-picks-scroll]');

      this.controls.forEach((control) => {
        control.addEventListener('click', () => {
          const direction = control.dataset.relatedPicksScroll === 'previous' ? -1 : 1;
          const cards = this.querySelectorAll('.retroease-related-picks__card');
          const firstCard = cards[0];
          const secondCard = cards[1];
          const firstRect = firstCard?.getBoundingClientRect();
          const secondRect = secondCard?.getBoundingClientRect();
          const cardStep = firstRect && secondRect
            ? secondRect.left - firstRect.left
            : firstRect?.width || this.viewport.clientWidth;
          const scrollAmount = cardStep * direction;

          this.viewport.scrollBy({
            left: scrollAmount,
            behavior: 'smooth'
          });
        });
      });
    }
  }

  if (!customElements.get('retroease-related-picks')) {
    customElements.define('retroease-related-picks', RetroeaseRelatedPicks);
  }

  } catch(e) { console.error(e); }
})();
})();
